"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _RadioChecked = _interopRequireDefault(require("@insided/shared/icons/RadioChecked"));

var _RadioUnchecked = _interopRequireDefault(require("@insided/shared/icons/RadioUnchecked"));

var RadioInputGroup = function RadioInputGroup(props) {
  var input = props.options.map(function (option, idx) {
    return (0, _preact.h)("label", {
      className: (0, _classnames.default)({
        flex: props.isFlexView,
        'radio-inline': !props.isFlexView,
        'radio-inline--underneath': !props.isFlexView && props.underneath
      }),
      key: props.key
    }, props.withRadioIcons ? (0, _preact.h)("div", {
      className: "radio-icons"
    }, option === props.value ? (0, _preact.h)(_RadioChecked.default, {
      className: "radio-checked"
    }) : (0, _preact.h)(_RadioUnchecked.default, {
      className: "radio-unchecked"
    })) : null, (0, _preact.h)("input", {
      type: "radio",
      name: props.name,
      className: (0, _classnames.default)("qa-".concat(option), {
        'radio-hidden': props.withRadioIcons
      }),
      required: props.required,
      disabled: props.disabled,
      key: props.key,
      onChange: function onChange() {
        if (props.onChange) {
          props.onChange(option, idx);
        }
      },
      onClick: function onClick() {
        if (props.onClick) {
          props.onClick(option, idx);
        }
      },
      checked: option === props.value
    }), props.hideOptionLabel === true ? null : option, props.valueDescriptions && (0, _preact.h)("p", {
      className: "radio-value-description"
    }, props.valueDescriptions[idx]));
  }).reduce(function (prev, curr) {
    return prev.concat([' ', curr]);
  }, []);
  return (0, _preact.h)("div", {
    className: "form-group ".concat(props.title ? 'qa-' + props.title.split(' ').join('') : '')
  }, props.title ? (0, _preact.h)("label", null, props.title) : null, props.desc ? (0, _preact.h)("p", {
    className: "radio-title-description"
  }, props.desc) : null, props.meta ? props.meta : null, (0, _preact.h)("div", {
    className: (0, _classnames.default)('radio-group', {
      'radio-group-disabled': props.disabled
    })
  }, input));
};

var _default = RadioInputGroup;
exports.default = _default;